import styled from '@emotion/styled'

import { breakpoints, spacing } from 'main/ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const CalloutSectionContainer = styled.div`
  column-gap: ${spacing.majorScale(1)}px;
  display: grid;
  grid-template-columns: 100%;
  margin-top: ${spacing.majorScale(1)}px;
  row-gap: ${spacing.majorScale(3)}px;
  width: 100%;

  @media (min-width: ${breakpoints.md}px) {
    grid-template-columns: 50% 50%;
  }

  @media (min-width: ${breakpoints.lg}px) {
    grid-template-columns: 33% 33% 33%;
  }
`

export const LoadMoreContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top: ${spacing.majorScale(6)}px;
`

export const ListingsHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ListingsRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  margin-bottom: ${spacing.minorScale(3)}px;
  margin-top: ${spacing.minorScale(2)}px;
`

export const DistanceSliderContainer = styled.div`
  flex-grow: 1;
  min-width: 20rem;

  @media (max-width: ${breakpoints.sm}px) {
    max-width: 100%;
  }

  @media (min-width: ${breakpoints.sm}px, max-width: ${breakpoints.md}px) {
    max-width: 50%;
  }

  @media (min-width: ${breakpoints.md}px, max-width: ${breakpoints.lg}px) {
    max-width: 35%;
  }

  @media (min-width: ${breakpoints.lg}px) {
    max-width: 28%;
  }
`
